import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import {
  createCustomer,
  deleteCustomer,
  updateCustomer,
} from "../../utils/customer";
import { db } from "../../index";
import Select from "react-select";
import { useProviderOptions } from "../../store/actions/providerActions";
import { FooterActionsContainer } from "../layout/Footer";
import { OutlineButton } from "../layout/OutlineButton";

export default function CustomerAddOrUpdateContent({ onCreated } = {}) {
  const history = useHistory();
  const params = useParams();
  const customerId = params.customer_id;

  const { userInfos } = useContext(UserContext);
  const providerOptions = useProviderOptions();

  const [formError, setFormError] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [customer, setCustomer] = useState({
    id: "",
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    civility: "",
    emailLanguage: "EN",
    favoriteAddress1: "",
    favoriteAddress2: "",
    searchLower: "",
    provider: {
      id: "",
      name: "",
      phone: "",
      tel: "",
      company: {
        id: "",
        name: "",
      },
    },
  });

  useEffect(() => {
    if (customerId && userInfos?.uid) {
      db.ref(`users/${userInfos.uid}/customer/${customerId}`)
        .once("value", (snapshot) => {
          const res = snapshot.val();
          setCustomer({ ...res, id: snapshot.key });
        })
        .then();
    }
  }, [customerId, userInfos?.uid]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomer((old) => ({
      ...old,
      [name]: value,
    }));
  };

  function handleProviderChange(obj) {
    setCustomer((old) => ({
      ...old,
      provider: {
        ...obj.data,
        key: obj.data.id,
      },
    }));
  }

  async function handleDeleteCustomer() {
    await deleteCustomer(userInfos, customerId);
    history.push("/passenger");
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    if (handleValidation()) {
      setIsFetching(true);

      if (customerId) {
        await updateCustomer(userInfos, customer);
        window.alert("Le passager a été mis à jour avec succès");
        if (onCreated) onCreated(customer);
      } else {
        await createCustomer(userInfos, customer);
        if (onCreated) onCreated(customer);
        else history.push("/passenger");
      }

      setIsFetching(false);
    }
  }

  const handleValidation = () => {
    let valid = true;
    let message = [];

    if (customer.firstname === "") {
      valid = false;
      message.push("Veuillez renseigner le prénom");
    }

    if (customer.lastname === "") {
      valid = false;
      message.push("Veuillez renseigner le nom");
    }

    if (customer.provider.id === "") {
      valid = false;
      message.push("Veuillez renseigner le client");
    }

    setFormError(message);

    return valid;
  };

  const renderFormAlert = () => {
    return formError.length > 0 ? (
      <div
        className="alert alert-danger mt-3"
        role="alert"
        style={{ flexDirection: "column", borderRadius: "0" }}
      >
        {formError.map((error, index) => {
          return (
            <div
              className="alert-text"
              key={index}
              style={{ alignSelf: "flex-start" }}
            >
              {error}
            </div>
          );
        })}
      </div>
    ) : null;
  };

  const buttonText =
    isFetching === true ? (
      <button type="submit" className="btn btn-primary px-5" disabled>
        {customerId ? "Mise à jour..." : "Création..."}
      </button>
    ) : (
      <button type="submit" className="btn btn-primary px-5">
        {customerId ? "Mettre à jour le passager" : "Créer le passager"}
      </button>
    );

  return (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">
              {customerId ? customer?.name : "Ajouter un passager"}{" "}
            </h3>
            <div className="kt-subheader__breadcrumbs">
              <Link to="/" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter"></i>
              </Link>
              <span className="kt-subheader__breadcrumbs-separator"></span>
              <Link to="/passenger/" className="kt-subheader__breadcrumbs-link">
                Passagers
              </Link>
              {customerId ? (
                <>
                  <span className="kt-subheader__breadcrumbs-separator"></span>
                  <Link
                    to={"/passenger/" + customerId}
                    className="kt-subheader__breadcrumbs-link"
                  >
                    {customer?.name}
                  </Link>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title">Données du passager</h3>
            </div>
          </div>
          <form onSubmit={handleFormSubmit} className="kt-form">
            <div className="kt-portlet__body">
                              <div className="kt-section kt-section--first">
                <div className="kt-section__body">
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Civilité:</label>
                    <div className="col-lg-6">
                      <select
                        value={customer.civility}
                        className="form-control"
                        name="civility"
                        onChange={handleChange}
                      >
                        <option value="">Mx</option>
                        <option value="mr">M.</option>
                        <option value="ms">Mme</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Prénom *:</label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        value={customer.firstname}
                        className="form-control"
                        name="firstname"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Nom *:</label>
                    <div className="col-lg-6">
                      <input
                        value={customer.lastname}
                        type="lastname"
                        className="form-control"
                        name="lastname"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Téléphone:
                    </label>
                    <div className="col-lg-6">
                      <input
                        type="tel"
                        className="form-control"
                        name="phone"
                        value={customer.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Email:</label>
                    <div className="col-lg-6">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={customer.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Langue e-mail:</label>
                    <div className="col-lg-6">
                      <select
                        value={customer.emailLanguage}
                        className="form-control"
                        name="emailLanguage"
                        onChange={handleChange}
                      >
                        <option value="FR">Français</option>
                        <option value="EN">Anglais</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Commentaire:
                    </label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="comments"
                        value={customer.comments}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Adresse favorite 1:
                    </label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="favoriteAddress1"
                        value={customer.favoriteAddress1}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">
                      Adresse favorite 2:
                    </label>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        name="favoriteAddress2"
                        value={customer.favoriteAddress2}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Client *:</label>
                    <div className="col-lg-6">
                      <Select
                        options={providerOptions}
                        value={providerOptions.find(
                          (option) => option.value === customer.provider.id
                        )}
                        onChange={handleProviderChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <FooterActionsContainer>
              <div>
                <OutlineButton type="button" onClick={history.goBack}>
                  <i className="fas fa-arrow-left" />
                  Retour
                </OutlineButton>
              </div>
              <div>{buttonText}</div>
              <div>
                {customerId && (
                  <OutlineButton
                    type="button"
                    data-toggle="modal"
                    data-target="#delete_modal"
                  >
                    <i className="fas fa-trash" />
                    Supprimer
                  </OutlineButton>
                )}
              </div>
            </FooterActionsContainer>
          </form>
          {renderFormAlert()}
        </div>
      </div>
      <div
        className="modal fade"
        id="delete_modal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Supprimer le passager
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Voulez-vous vraiment supprimer le passager ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Annuler
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={handleDeleteCustomer}
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
